import React, {useEffect, useState} from "react";
import {getJSON, post, page, card, darkBtn, primaryBtn} from "./ui";
import {ZedSays} from "./zed";
import {FlySwap} from "./fly";

// Kickoff's interview: your phone shows Zed's questions about your partner. Read
// each one aloud, with its three options, and tap what they answer. They're doing
// the same for you at the same time.
export const InterviewPhase = ({state, offset}) => {
    const [data, setData] = useState(null);
    const [picked, setPicked] = useState(null);
    useEffect(() => {
        let live = true;
        getJSON('/demo/interview').then(d => { if (live) setData(d); });
        return () => { live = false; };
    }, []);

    if (!data) return <div style={{...page, alignItems: 'center', justifyContent: 'center'}}>…</div>;
    const questions = data.questions || [];
    const answers = data.answers || [];
    const index = questions.findIndex((_, i) => !answers[i]);

    // The tapped answer lights up and holds a moment before the question sweeps off with it.
    const answer = async (option) => {
        if (picked) return;
        setPicked(option);
        const [res] = await Promise.all([post('/demo/answer', {index, answer: option}), new Promise(r => setTimeout(r, 500))]);
        setPicked(null);
        if (res.ok) setData(d => {
            const next = [...(d.answers || [])];
            next[index] = option;
            return {...d, answers: next};
        });
    };

    return <div style={{...page, gap: 16}}>
        <div>
            <ZedSays line={index === -1 ? `Good. ${data.partner.name} has confessed.` : `Ask ${data.partner.name} this. Out loud. Tap their answer.`} />
        </div>
        {/* each answered question sweeps off and the next slides in, like a screen change */}
        <FlySwap swapKey={index}>
            <div style={{display: 'flex', flexDirection: 'column', gap: 16}}>
                {index === -1
                    ? <Done partner={data.partner} answers={answers} questions={questions} />
                    : <>
                        <div style={{...card, padding: '18px 16px', textAlign: 'center', fontSize: 28, fontWeight: 800, lineHeight: 1.2}}>
                            {questions[index].question}
                        </div>
                        {questions[index].options.map(o => (
                            <button key={o} onClick={() => answer(o)} style={picked === o
                                ? {...primaryBtn, fontSize: 21, padding: '16px 12px', textTransform: 'none', letterSpacing: 0}
                                : {...darkBtn, fontSize: 21, padding: '16px 12px', textTransform: 'none', letterSpacing: 0,
                                    opacity: picked ? 0.4 : 1, transition: 'opacity 200ms ease'}}>
                                {picked === o ? `✓ ${o}` : o}
                            </button>
                        ))}
                        <div style={{textAlign: 'center', opacity: 0.5}}>Question {index + 1} of {questions.length}</div>
                    </>}
            </div>
        </FlySwap>
    </div>;
};

const Done = ({partner, answers, questions}) => (
    <div style={{display: 'flex', flexDirection: 'column', gap: 12}}>
        <div style={{fontSize: 24, fontWeight: 800, textAlign: 'center'}}>{partner.name}'s file, by their own admission:</div>
        {questions.map((q, i) => (
            <div key={i} style={{...card, padding: '12px 14px'}}>
                <div style={{fontSize: 16, opacity: 0.6}}>{q.question}</div>
                <div style={{fontSize: 22, fontWeight: 800}}>{answers[i]}</div>
            </div>
        ))}
    </div>
);
